import { isBrowser } from "./general"

export const readSessionMaxicareNumber = () => {
  if (!isBrowser()) return ""

  try {
    const authState = sessionStorage.getItem("authState")
    if (!authState) return ""

    const parsedAuthState = JSON.parse(authState)
    return parsedAuthState?.maxicareCardNumber || ""
  } catch (error) {
    console.error(error)
    return ""
  }
}

// The actual proof of eligibility is an HttpOnly cookie set by
// GET /maxicare/:cardNumber (see functions/src/lib/session.js) - it's never
// readable from JS, so it can't be exfiltrated by a same-origin script
// compromise the way the old sessionStorage-held token could. This flag is
// just local UI/routing state ("did this browser complete the check") used
// to pick the member-only vs. public Zendesk endpoints in zendeskService.js;
// it grants nothing by itself since every member-only route still verifies
// the cookie server-side.
export const readIsMemberSession = () => {
  if (!isBrowser()) return false

  try {
    const authState = sessionStorage.getItem("authState")
    if (!authState) return false

    const parsedAuthState = JSON.parse(authState)
    return !!parsedAuthState?.isMemberSession
  } catch (error) {
    console.error(error)
    return false
  }
}
